import { useEffect } from "react";

/**
 * Hook qui déconnecte l'utilisateur après 10 minutes d'inactivité
 * Détecte l'inactivité via les événements: click, keypress, mousemove, scroll, touch
 * @param {number} timeoutMinutes - Délai d'inactivité en minutes (default: 10)
 */
const useInactivityTimeout = (timeoutMinutes = 10) => {
    useEffect(() => {
        // Convertir les minutes en millisecondes
        const timeoutMs = timeoutMinutes * 60 * 1000;

        // Ref pour le timeout
        let inactivityTimer;

       // Fonction pour effacer les données utilisateur et rediriger
     
        const handleLogout = () => {
            console.warn(`Inactivité détectée après ${timeoutMinutes} minutes. Déconnexion...`);
            localStorage.removeItem("authUser");
            localStorage.removeItem("token");
            window.location.href = "/auth-login";
        };

        // Réinitialiser le timer à chaque activité détectée
         
        const resetTimer = () => {
            // Effacer le timer précédent s'il existe
            if (inactivityTimer) {
                clearTimeout(inactivityTimer);
            }

            // Lancer un nouveau timer
            inactivityTimer = setTimeout(handleLogout, timeoutMs);
        };

        // Liste des événements qui réinitialisent le timer
        const events = ["mousedown", "keydown", "scroll", "touchstart", "click"];

        // Ajouter les event listeners
        events.forEach((event) => {
            document.addEventListener(event, resetTimer);
        });

        // Lancer le timer initial
        resetTimer();

        // Cleanup
        return () => {
            // Enlever les event listeners
            events.forEach((event) => {
                document.removeEventListener(event, resetTimer);
            });

            // Effacer le timer
            if (inactivityTimer) {
                clearTimeout(inactivityTimer);
            }
        };
    }, [timeoutMinutes]);
};

export default useInactivityTimeout;
